































































import { Component, Prop, Vue } from "vue-property-decorator";
import { CatatanMedisRah } from "@/types/rekam_asuhan_hemodialisis";

@Component({})
export default class ObatCatatanMedisCard extends Vue {
  @Prop({ type: Array, required: true })
  readonly catatanMedis!: CatatanMedisRah[];
  @Prop({ type: Number, default: 20 }) readonly maks!: number;
  @Prop({ type: Boolean, default: false }) readonly disabled!: boolean;

  tambah() {
    this.catatanMedis.push({ obat: null, catatan: null });
  }

  hapus(index: number) {
    this.catatanMedis.splice(index, 1);
    if (!this.catatanMedis.length) this.tambah();
  }
}
